<script lang="ts" setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { t } from "i18next";

const route = useRoute();
const router = useRouter();

const breadcrumbs = computed(() => {
	const paths = route.path.split("/").filter((path) => path);
	const breadcrumbArray = paths.map((path, index) => {
		const to = `/${paths.slice(0, index + 1).join("/")}`;
		const routeMatch = router.resolve(to);
		return {
			text: routeMatch.name || path,
			to,
		};
	});
	return [{ text: t("Página Inicial"), to: "/" }, ...breadcrumbArray];
});
</script>

<template>
    <Breadcrumb class="pl-4 lg:pb-4">
        <BreadcrumbList>
            <BreadcrumbItem v-for="(breadcrumb, index) in breadcrumbs" :key="index">
                <BreadcrumbLink v-if="index < breadcrumbs.length - 1" as-child>
                    <RouterLink :to="breadcrumb.to">
                        <span>
                            {{ breadcrumb.text }}
                        </span>
                    </RouterLink>
                </BreadcrumbLink>
                <BreadcrumbPage v-else>
                    <span>{{ breadcrumb.text }}</span>
                </BreadcrumbPage>
                <BreadcrumbSeparator v-if="index < breadcrumbs.length - 1" />
            </BreadcrumbItem>
        </BreadcrumbList>
    </Breadcrumb>
</template>
